import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class Testimonial extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="testimonial-area pd-top-100"  style={{backgroundImage: 'url("'+publicUrl+'assets/img/website/miet-testimonial-bg.jpg")', backgroundRepeat:'no-repeat', backgroundSize:'contain'}}>
			  <div className="container"> 
				  <div className="section-title text-center">
					<ScrollAnimation animateIn="fadeInDown">
						<h6 className="sub-title double-line"> Testimonials</h6>
						<h2 className="title"> Wall of Love </h2>
					</ScrollAnimation>
				  </div>
			    <div className="testimonial-area-inner bg-cover" style={{backgroundImage: 'url("'+publicUrl+'assets/img/other/2.png")'}}>
			      {/* <img className="testimonial-right-img" src={publicUrl+"assets/img/website/pngegg.png"} alt="img" /> */}
			      <img className="testimonial-right-img" />
			      <div className="testimonial-slider owl-carousel">
			        <div className="item">
			          <div className="single-testimonial-inner style-white">
			            <span className="testimonial-quote"><i className="fa fa-quote-left" /></span>
			            <p className="mb-4">Class was really nice and it was useful to me to clear JEE Main. Materials given by you are very helpful to practice Sir.</p>
			            <div className="media testimonial-author">
			              <div className="media-body align-self-center">
			                <h6>- Nandini</h6>
			              </div>
			            </div>
			          </div>
			        </div>
			        <div className="item">
			          <div className="single-testimonial-inner style-white">
			            <span className="testimonial-quote"><i className="fa fa-quote-left" /></span>
			            <p className="mb-4">Hi, Im Maran, pursuing my data science course in MIET. Good teaching and very understanding teachers. Guiding me and teaching me when im in doubt.</p>
			            <div className="media testimonial-author">
						  <div className="media-body align-self-center">
			                <h6>- Maran</h6>
			              </div>
			            </div>
			          </div>
			        </div>
					<div className="item">
			          <div className="single-testimonial-inner style-white">
			            <span className="testimonial-quote"><i className="fa fa-quote-left" /></span>
			            <p className="mb-4">Hello, Im Indu from NRA CET coaching class. Well trained staff and good teaching for me to prepare for my railways exam.</p>
			            <div className="media testimonial-author">
						  <div className="media-body align-self-center">
			                <h6>- Indu</h6>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>

        }
}

export default Testimonial